import { inject, Injectable } from '@angular/core';
import { AbstractFinderService } from '@df/catalog/abstract-finder/abstract-finder.service';
import { IStoreData, Store } from '@df/catalog/store/store';
import { StoreResource } from './store.resource';

@Injectable({
    providedIn: 'root'
})
export class StoreService extends AbstractFinderService<Store, IStoreData> {
    protected type = 'store';
    protected requestPath = 'locateStore';

    override resource = inject(StoreResource)
}
